import React from 'react';
import { connect } from 'react-redux';
import {
	setNewMediaDevice,
	refreshLocalMedia,
	toggleLocalMediaStreamMute,
	toggleVoiceOptimization,
	toggleAutoGainControl,
	toggleLowBandwidthMode, toggleHighBandwidthMode,
	toggleEnableBlurBackground
} from '../../../../Redux/Actions/mediaActions';
import { setAutoAnswer } from '../../../../Redux/Actions/callActions';

import SettingsMenuPresentation from './SettingsMenuPresentation';
import CustomVideo from '../../../CustomVideo';
import LocalMediaHandler from '../../../../Utilities/Gnural/LocalMediaHandler';

import style from './MediaPanel.module.css';

function mapStateToProps(store) {
	return ({
		audioInputList: store.media.audioInputList,
		audioOutputList: store.media.audioOutputList,
		videoInputList: store.media.videoInputList,
		videoResolutionObject: store.media.videoResolutionObject,
		currentAudioInput: store.media.currentAudioInput,
		currentAudioOutput: store.media.currentAudioOutput,
		currentVideoInput: store.media.currentVideoInput,
		currentVideoResolution: store.media.currentVideoResolution,
		autoGainControl: store.media.autoGainControl,
		voiceOptimization: store.media.voiceOptimization,
		lowBandwidthMode: store.media.lowBandwidthMode,
		highBandwidthMode: store.media.highBandwidthMode,
		enableBlurBackground: store.media.enableBlurBackground,
		localMediaStreamID: store.media.localMediaStreamID,
		isProcessing: store.media.isProcessing,
		isChrome: store.sessionInformation.isChrome,
		isEdge: store.sessionInformation.isEdge,
		isChromiumBased: store.sessionInformation.isChromiumBased,
		autoAnswer: store.call.AutoAnswer,
		UserId: store.user.UserId,
		isMuted: store.media.isMuted,
		areTotalDevicesChanged: store.media.areTotalDevicesChanged,
		qualityLimitationReason: store.stats.qualityLimitationReason,
	});
}

class MediaPanel extends React.Component {
	constructor(props) {
		super(props);
		// Do stuff with binding
		this.onUpdateSelectGeneric = this.onUpdateSelectGeneric.bind(this);
		this.onUpdateVideoResolution = this.onUpdateVideoResolution.bind(this);
		this.onRefreshLocalMedia = this.onRefreshLocalMedia.bind(this);
		this.onToggleAutoAnswer = this.onToggleAutoAnswer.bind(this);
		this.onToggleLocalMediaStreamMute = this.onToggleLocalMediaStreamMute.bind(this);
		this.onToggleAutoGainControl = this.onToggleAutoGainControl.bind(this);
		this.onToggleVoiceOptimization = this.onToggleVoiceOptimization.bind(this);
		this.onToggleLowBandwidthMode = this.onToggleLowBandwidthMode.bind(this);
		this.onToggleHighBandwidthMode = this.onToggleHighBandwidthMode.bind(this);
		this.onToggleEnableBlurBackground = this.onToggleEnableBlurBackground.bind(this);
		this.getMediaSettingsLabel = this.getMediaSettingsLabel.bind(this);
		this.getMediaSettingsLabelClass = this.getMediaSettingsLabelClass.bind(this);

		this.state = {
			localStream: undefined
		};
	}

	componentDidMount() {
		this.setState({
			localStream: LocalMediaHandler.getLocalMediaStream()
		});
	}

	componentDidUpdate(nextProps) {
		if (nextProps.localMediaStreamID !== this.props.localMediaStreamID) {
			this.setState({
				localStream: LocalMediaHandler.getLocalMediaStream()
			});
		}
	}

	onRefreshLocalMedia() {
		this.props.dispatch(refreshLocalMedia());
	}

	onUpdateSelectGeneric(selectType, event) {
		if (!event || !event.target || !selectType) {
			return;
		}
		const currentlySelectedObject = event.target.options[event.target.selectedIndex].value;
		if (!currentlySelectedObject) {
			return;
		}
		const desiredItem = this.props[selectType].filter(objects => {
			return objects.deviceId === currentlySelectedObject;
		});
		if (!desiredItem[0]) {
			return;
		}
		this.props.dispatch(setNewMediaDevice(selectType, desiredItem[0]));
	}

	onUpdateVideoResolution(event) {
		if (!event || !event.target) {
			return;
		}

		const currentlySelectedResolution = event.target.options[event.target.selectedIndex];
		if (!currentlySelectedResolution) {
			return;
		}
		const desiredResolution = this.props.videoResolutionObject[this.props.currentVideoInput.deviceId].filter(
			(resolution) => {
				return resolution.friendlyName === currentlySelectedResolution.value;
			})[0];
		if (!desiredResolution) {
			return;
		}
		this.props.dispatch(setNewMediaDevice('videoResolutionObject', desiredResolution));
	}

	onToggleAutoAnswer() {
		this.props.dispatch(setAutoAnswer(!this.props.autoAnswer));
	}

	onToggleLocalMediaStreamMute() {
		this.props.dispatch(toggleLocalMediaStreamMute());
	}

	onToggleVoiceOptimization() {
		this.props.dispatch(toggleVoiceOptimization());
	}

	onToggleLowBandwidthMode() {
		this.props.dispatch(toggleLowBandwidthMode());
	}

	onToggleHighBandwidthMode() {
		this.props.dispatch(toggleHighBandwidthMode());
	}

	onToggleEnableBlurBackground() {
		this.props.dispatch(toggleEnableBlurBackground());
	}

	onToggleAutoGainControl() {
		this.props.dispatch(toggleAutoGainControl());
	}

	getMediaSettingsLabel() {
		if (!this.props.qualityLimitationReason || this.props.qualityLimitationReason === 'none') return 'Local Media Settings:';
		switch (this.props.qualityLimitationReason) {
			case 'cpu': return 'Local Hardware Overloaded';
			case 'bandwidth': return 'Limited Network Bandwidth Available';
			case 'other': return 'Connection Deprecated [Unknown Reason]';
		}
		return 'Connection Deprecated [Unknown Reason]';
	}

	getMediaSettingsLabelClass() {
		if (!this.props.qualityLimitationReason || this.props.qualityLimitationReason === 'none') return [ style.MediaSettingsLabel ].join(' ');
		return [ style.MediaSettingsLabel, style.MediaSettingsLabelError ].join(' ');
	}

	render() {
		return (
			<div className={style.MediaPanelWrapper}>
				<div className={style.LocalVideoWrapper}>
					<CustomVideo
						className={[style.LocalVideo].join(' ')}
						srcObject={this.state.localStream}
						muted={true}
						shouldContainFraming={true}
						VideoFramingStyle={style.VideoFraming}
					/>
					{this.props.isProcessing ? 
						<div className={style.IsProcessingWrapper}>
							<div className={style.IsProcessingGraphic}>
								<div className={style.IsProcessingGraphicInner}>Loading</div>
							</div>
						</div>
						:
						null
					}
				</div>
				<div className={style.HeadingWrapper}>
					<div className={this.getMediaSettingsLabelClass()}>{this.getMediaSettingsLabel()}</div>
				</div>
				<SettingsMenuPresentation
					currentVideoInput={this.props.currentVideoInput}
					videoInputList={this.props.videoInputList}
					currentAudioInput={this.props.currentAudioInput}
					audioInputList={this.props.audioInputList}
					currentAudioOutput={this.props.currentAudioOutput}
					audioOutputList={this.props.audioOutputList}
					resolutionList={
						(this.props.currentVideoInput && this.props.videoResolutionObject[this.props.currentVideoInput.deviceId] ? 
							this.props.videoResolutionObject[this.props.currentVideoInput.deviceId] : 
							[]
						)
					}
					currentVideoResolution={this.props.currentVideoResolution}
					isChrome={this.props.isChrome}
					isEdge={this.props.isEdge}
					isChromiumBased={this.props.isChromiumBased}
					onUpdateSelectGeneric={this.onUpdateSelectGeneric}
					onUpdateVideoResolution={this.onUpdateVideoResolution}
					onRefreshLocalMedia={this.onRefreshLocalMedia}
					onAutoforwardChange={this.onAutoforwardChange}
					onToggleAutoAnswer={this.onToggleAutoAnswer}
					onToggleLocalMediaStreamMute={this.onToggleLocalMediaStreamMute}
					onToggleAutoGainControl={this.onToggleAutoGainControl}
					onToggleVoiceOptimization={this.onToggleVoiceOptimization}
					onToggleLowBandwidthMode={this.onToggleLowBandwidthMode}
					onToggleHighBandwidthMode={this.onToggleHighBandwidthMode}
					onToggleEnableBlurBackground={this.onToggleEnableBlurBackground}
					autoGainControl={this.props.autoGainControl}
					voiceOptimization={this.props.voiceOptimization}
					lowBandwidthMode={this.props.lowBandwidthMode}
					highBandwidthMode={this.props.highBandwidthMode}
					enableBlurBackground={this.props.enableBlurBackground}
					currentAutoForward={this.props.autoForward}
					autoAnswer={this.props.autoAnswer}
					UserId={this.props.UserId}
					isMuted={this.props.isMuted}
					areTotalDevicesChanged={this.props.areTotalDevicesChanged}
				/>
			</div>
		);
	}
}
//<button className='custom-secondary-button' onClick={this.openSettingsModal}> Settings </button>

export default connect(mapStateToProps)(MediaPanel);
